import { useState } from 'react';
import EdtitingAndAddingUserModal from './EditingAndAddingUserModal';
import classNames from 'classnames';
import Swal from 'sweetalert2';
import loadingGif from '../../assets/Other/loading.gif';
import request from '../../utils/APIHelper/request';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import { toast } from 'react-toastify';
import PasswordResetWindow from '../PasswordReset/PasswordResetWindow';

const EditingUserFrame = ({ data, swalModal }) => {
  const [newData, setNewData] = useState(data);
  const [updateLoading, setUpdateLoading] = useState();

  const update = async () => {
    const result = await request({
      url: `${controllers.user}updateUser`,
      type: requestTypes.post,
      params: { id: data.id },
      body: newData,
      setLoading: setUpdateLoading,
      disableLogOut: true,
    });
    if (result?.code === responseTypes.success) {
      toast.success(result?.message || 'Success!');
      window.location.reload();
      Swal.close();
    } else {
      toast.error(
        "Something went wrong when trying to update user! Check if user's email is unqiue.",
      );
    }
  };

  const resetPassword = async (userId) => {
    swalModal.fire({
      title: 'Reset password',
      html: <PasswordResetWindow swalModal={swalModal} userId={userId} />,
      showCancelButton: false,
      showConfirmButton: false,
      cancelButtonText: 'Close',
      customClass: {
        confirmButton: 'bg-blue-800 text-white hover:bg-blue-900',
        cancelButton: 'bg-gray-300 text-gray-800 hover:bg-gray-400',
        popup: 'w-auto max-w-[65%] text-sm',
      },
    });
  };
  return (
    <div>
      <div>
        <EdtitingAndAddingUserModal
          data={newData}
          setData={setNewData}
          recentlyUpdatedData={data}
        />
      </div>
      <div>
        <div
          className={classNames(
            'text-left text-sm my-1',
            JSON.stringify(data) === JSON.stringify(newData)
              ? 'text-yellow-600'
              : 'opacity-0',
          )}
        >
          No changes to save
        </div>
        {updateLoading ? (
          <img
            className="w-5 h-5 mx-auto float-left my-2 mx-[1.1rem]"
            src={loadingGif}
          />
        ) : (
          <div
            onClick={update}
            className={classNames(
              'float-left bg-blue-900 text-white inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer hover:bg-blue-800 hover:transition-all hover:duration-300',
              JSON.stringify(data) === JSON.stringify(newData) &&
                '!bg-gray-400 !cursor-auto',
            )}
          >
            Save
          </div>
        )}

        <div
          onClick={() => resetPassword(data.id)}
          className={classNames(
            'float-center bg-red-800 text-white inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer hover:bg-red-900 hover:transition-all hover:duration-300',
          )}
        >
          Reset password
        </div>

        <div
          onClick={() => Swal.close()}
          className={classNames(
            'float-right bg-gray-300 text-gray-700 inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer hover:bg-gray-400 hover:transition-all hover:duration-300',
          )}
        >
          Close
        </div>
      </div>
    </div>
  );
};

export default EditingUserFrame;
